<script lang="ts">
  export let variant: 'default' | 'info' | 'success' | 'warning' | 'error' =
    'default';
  export let iconPosition: 'left' | 'right' = 'left';

  const SLOTS = $$props.$$slots;
</script>

<style lang="postcss">
  .note {
    position: relative;
    width: 100%;
    padding: var(--ubilabs-note-padding);
    border-radius: var(--ubilabs-note-border-radius);
    background-color: var(--ubilabs-note-background-color);
    color: var(--ubilabs-note-color);
    font-size: var(--ubilabs-note-font-size);
  }

  .info {
    background-color: var(--ubilabs-info-background-color);
    color: var(--ubilabs-info-color);
  }

  .success {
    background-color: var(--ubilabs-success-background-color);
    color: var(--ubilabs-success-color);
  }

  .warning {
    background-color: var(--ubilabs-warning-background-color);
    color: var(--ubilabs-warning-color);
  }

  .error {
    background-color: var(--ubilabs-error-background-color);
    color: var(--ubilabs-error-color);
  }

  .note:not(.withIcon) > *:last-child,
  .withIcon > *:last-child > *:last-child {
    margin-bottom: 0;
  }

  .withIcon {
    display: flex;
    gap: 0.5rem;
  }

  .withIcon.right {
    flex-direction: row-reverse;
  }

  .icon {
    margin: 0.125rem 0;
    border-radius: 50%;
  }
</style>

<div
  class="note {variant} {SLOTS.icon &&
    `withIcon ${iconPosition}`} {$$props.class}">
  {#if SLOTS.icon}
    <div class="icon"><slot name="icon" /></div>
    <div><slot /></div>
  {:else}
    <slot />
  {/if}
</div>
